import React from 'react';
import { useProjectName } from '../../../../services/hooks/selectors/panel.selectors';

export const ProjectName: React.FC = () => {
    const name = useProjectName();

    return (
        <>{name}</>
    )
}